// Fields that should be cleared when the user navigates back
const fieldsToClearOnBack = ['schedule']

/**
 * Navigate to the previous step and clear any fields that depend on the current step.
 *
 * @param {Function} setCurrentStepIndex - React state setter for the step index
 * @param {Function} setFieldValue - Form context setter (handles state correctly, no mutation)
 */
const goPrevStep = (setCurrentStepIndex, setFieldValue) => {
  document.activeElement.blur()
  setCurrentStepIndex((prevIndex) => prevIndex - 1)

  fieldsToClearOnBack.forEach((fieldName) => {
    setFieldValue(fieldName, undefined)
  })
}

export default goPrevStep
